import { render, staticRenderFns } from "./FileOperateBtn.vue?vue&type=template&id=f7ee030a&scoped=true"
import script from "./FileOperateBtn.vue?vue&type=script&lang=ts"
export * from "./FileOperateBtn.vue?vue&type=script&lang=ts"
import style1 from "./FileOperateBtn.vue?vue&type=style&index=1&id=f7ee030a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ee030a",
  null
  
)

export default component.exports